import { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import styles from "./cart.module.css";
import { Pagination, SubHeadingTitle } from "../../../components/shared";
import CartMainContent from "./CartMainContent";
import {
  useDecreaseCartQty,
  useIncreaseCartQty,
  useRemoveCartItem,
} from "../../../queries/useCartQuery";
import { useShippingRulesQuery } from "../../../queries/useOrderQuery";
import CheckoutShipping from "../Checkout/CheckoutShipping/CheckoutShipping";
import { useOrderSummary } from "../../../hooks/useOrderSummary";
import CartOrderSummary from "./CartOrderSummary";
import { useNavigate } from "react-router-dom";
const Cart = () => {
  const navigate = useNavigate();
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [selectLoading, setSelectLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { data: shippingRulesData = [], isPending: isShippingPending } =
    useShippingRulesQuery();
  const [selectedShipping, setSelectedShipping] = useState(() => {
    const saved = localStorage.getItem("shipping-rules");
    return saved ? JSON.parse(saved) : null;
  });
  const { cartItems, isPending, subtotal, shipping, total, error } =
    useOrderSummary(selectedShipping);
  const increaseQty = useIncreaseCartQty();
  const decreaseQty = useDecreaseCartQty();
  const deleteMutation = useRemoveCartItem();
  const removedOutOfStockRef = useRef(new Set()); 
  const handleShippingSelect = (rule) => {
    setSelectedShipping(rule);
    localStorage.setItem("shipping-rules", JSON.stringify(rule));
  };
  const updateQuantityIncrease = (productId) => {
    increaseQty.mutate({ product_id: productId, quantity: 1 });
  };
  const updateQuantityDecrease = (productId, currentQty) => {
    if (currentQty <= 1) return;
    decreaseQty.mutate({ product_id: productId, quantity: 1 });
  };
  const removeItem = (id) => deleteMutation.mutate(id); 
const handleSelectItem = (itemId) => {
  setSelectLoading(true);

  setSelectedItems((prev) =>
    prev.includes(itemId)
      ? prev.filter((id) => id !== itemId)
      : [...prev, itemId]
  );

  setTimeout(() => {
    setSelectLoading(false);
  }, 300);
};
useEffect(() => {
  if (!cartItems || cartItems.length === 0) return;

  cartItems.forEach((item) => {
    if (
      item?.product?.qty === 0 &&
      !removedOutOfStockRef.current.has(item.id)
    ) {
      removedOutOfStockRef.current.add(item.id);

      // silently remove item
      removeItem(item.id);
    }
  });
}, [cartItems]);
 const [selectedItems, setSelectedItems] = useState([]);

useEffect(() => {
  if (cartItems?.length > 0) {
    setSelectedItems((prev) => {
      // Only initialize when nothing selected
      if (prev.length === 0) {
        return cartItems.map((item) => item.id);
      }

      // Keep selected items synced with cart
      return prev.filter((id) =>
        cartItems.some((item) => item.id === id)
      );
    });
  }
}, [cartItems]);
 const isAllSelected =
  cartItems?.length > 0 &&
  cartItems.every((item) =>
    selectedItems.includes(item.id)
  );

const handleSelectAll = () => {
  setSelectLoading(true);

  setSelectedItems(cartItems.map((item) => item.id));
  setTimeout(() => {
    setSelectLoading(false);
  }, 300);
};
const handleDeleteSelected = async () => {
  if (selectedItems.length === 0) {
    toast.error("Please select items");
    return;
  }

  try {
    setDeleteLoading(true);

    for (const itemId of selectedItems) {
      await deleteMutation.mutateAsync(itemId);
    }

    toast.success(`${selectedItems.length} item(s) removed`);

    setSelectedItems([]);
  } catch (error) {
    toast.error("Failed to remove items");
  } finally {
    setDeleteLoading(false);
  }
};
  const [currentPage, setCurrentPage] = useState(1);
  const per_page = 5;
  const indexOfLast = currentPage * per_page;
  const indexOfFirst = indexOfLast - per_page;
  const currentCartItems = cartItems?.slice(
    indexOfFirst,
    indexOfLast
  );
 const selectedCartItems = cartItems.filter((item) =>
  selectedItems.includes(item.id)
);
const selectedItemCount = selectedCartItems.reduce(
  (acc, item) => acc + Number(item.quantity || 1),
  0
);
const selectedSubtotal = selectedCartItems.reduce((acc, item) => { 
  const selectedItemCount = selectedCartItems.reduce(
  (acc, item) => acc + Number(item.quantity || 1),
  0
);
  const price = Number(
    item.product?.offer_price ||
      item.product?.price ||
      0
  );

  return acc + price * item.quantity;
}, 0);

console.log("FULL SHIPPING OBJECT", selectedShipping);

const selectedShippingCost =
  Number(selectedShipping?.cost || 0);

const selectedTotal = selectedSubtotal + selectedShippingCost;
const handleCheckOutPayment = () => {
  if (selectedItems.length === 0) {
    toast.error("Please select products");
    return;
  }

  setCheckoutLoading(true);

  localStorage.setItem(
    "selectedCheckoutItems",
    JSON.stringify(selectedCartItems)
  );

  setTimeout(() => {
    navigate("/checkout");
  }, 500);
};
  if (error) {
    return (
      <section className={styles.cart__wrapper}>
        <div className={styles.emptyCartWrapper}>
          <SubHeadingTitle
            subTitle="Please login to check cart items & proceed to checkout..."
            style={styles.cartError}
          />
        </div>
      </section>
    );
  }
  return (
    <section className={styles.cart__wrapper}>
     <div className={styles.cartSection}>

<div className={styles.selectAllWrapper}>
 <button
  className={styles.selectAllBtn}
  onClick={handleSelectAll}
  disabled={selectLoading || isAllSelected}
>
  {selectLoading ? (
    <>
      <span className={styles.spinner}></span>
      Loading...
    </>
  ) : (
    "Select All"
  )}
</button>

  <button
    className={styles.deleteSelectedBtn}
    onClick={handleDeleteSelected}
    disabled={selectedItems.length === 0}
  >
  {deleteLoading ? (
  <>
    <span className={styles.spinner}></span>
    Deleting...
  </>
) : (
  `Delete Selected (${selectedItems.length})`
)}
  </button>
</div>

  <CartMainContent
          cartItems={currentCartItems}
          isLoading={isPending}
          removeItem={removeItem}
          updateQuantityInc={updateQuantityIncrease}
          updateQuantityDec={updateQuantityDecrease}
          styles={styles} 
           selectedItems={selectedItems}
        handleSelectItem={handleSelectItem}
        />
      </div>
      {currentCartItems?.length > 0 && (
        <div className={styles.shippingInfoBanner}>
          <p>✅COD available above Rs. 500/-</p>
          <p>🚚 Delivery in 4–5 Days (Prepaid)</p>
          <p>💵 COD Charges: ₹100</p>
          <p>🚚 Delivery in 6–7 Days (COD)</p>
        </div>
      )}
      {cartItems?.length > per_page && (
        <Pagination
          currentPage={currentPage}
          total={cartItems.length}
          per_page={per_page}
          handlePageChange={setCurrentPage}
        />
      )}
      {currentCartItems?.length > 0 && (
        <div className={styles.bottomRow}>
          {!isShippingPending && (
            <CheckoutShipping
              shippingRules={shippingRulesData}
              selectedShipping={selectedShipping}
              setSelectedShipping={handleShippingSelect}
              subtotal={selectedSubtotal}
            />
          )}
         <CartOrderSummary
  styles={styles}
  subtotal={selectedSubtotal}
   shippingCost={selectedShippingCost}
  totalAmount={selectedTotal}
  onButtonClick={handleCheckOutPayment} 
   loading={checkoutLoading}
    selectedCount={selectedItemCount}
/>
        </div>
      )}
    </section>
  );
};
export default Cart;